mutation UserSetupUploadDocument(
  $document: DocumentUploadInput!
  $userSetupId: UUID!
) {
  userSetupUploadDocument(document: $document, userSetupId: $userSetupId) {
    uploadLink
    document {
      id
      _documentFileId
    }
  }
}
